export const sortArrayBasedOnId = (array) => {
  const sortedItem = array?.filter((a) => true).sort((a, b) => b.id - a.id);
  return sortedItem;
};
